import { PulseBaseProvider } from '../../base-classes';
import { getLength, getTemperature, getPressure, getSpeed } from '../../utilities/unitConversion';

const _currentStationObsUri = '/data/observations/v4/current';
const _currentStationObsCacheKey = 'currentStationObs';

export class CurrentStationObsProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_currentStationObsCacheKey] = this.currentStationObsSyncer.bind(this);
    }

    async currentStationObsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            location: syncParams.location,
            locationtype: syncParams.locationtype,
            offset: syncParams.offset,
            units: 'English',
            verbose: syncParams.verbose,
            stationId: syncParams.stationId,
            providerId: syncParams.providerId
        };

        const { lengthUnit, tempUnit, pressureUnit, speedUnit } = syncParams;
        const unitConversionFunc = (result) => {
            if (result) {
                if (result.hl) {
                    result.hl.th = getTemperature(result.hl.th, tempUnit);
                    result.hl.tl = getTemperature(result.hl.tl, tempUnit);
                    result.hl.pslh = getPressure(result.hl.pslh, pressureUnit);
                    result.hl.psll = getPressure(result.hl.psll, pressureUnit);
                }
                if (result.o) {
                    result.o.t = getTemperature(result.o.t, tempUnit);
                    result.o.fl = getTemperature(result.o.fl, tempUnit);
                    result.o.wc = getTemperature(result.o.wc, tempUnit);
                    result.o.dp = getTemperature(result.o.dp, tempUnit);
                    result.o.psl = getPressure(result.o.psl, pressureUnit);
                    result.o.rr = getLength(result.o.rr, lengthUnit, false, 2);
                    result.o.rd = getLength(result.o.rd, lengthUnit, false, 2);
                    result.o.rm = getLength(result.o.rm, lengthUnit, false, 2);
                    result.o.ws = getSpeed(result.o.ws, speedUnit);
                    result.o.wsa = getSpeed(result.o.wsa, speedUnit);
                    result.o.wgh = getSpeed(result.o.wgh, speedUnit);
                    result.o.hi = getTemperature(result.o.hi, tempUnit);
                }
            }

            return result;
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _currentStationObsUri, resolve, reject, responseValidator, syncParams.pulseApi, null, unitConversionFunc);
    }

    async getCurrentStationObs(location, locationtype, offset, units, stdParameters, verbose, refresh = false, lengthUnit, tempUnit, pressureUnit, speedUnit, stationId, providerId) {
        const syncParams = {
            location,
            locationtype,
            offset: offset && offset >= 0 ? offset : 0,
            units: units ? units : 'english',
            verbose: !!verbose,
            refresh,
            lengthUnit,
            tempUnit,
            pressureUnit,
            speedUnit,
            stationId,
            providerId
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_currentStationObsCacheKey, id);
        }
        return await super.loadFromStorage(_currentStationObsCacheKey, id, syncParams);
    }
}

